import { jsx as l } from "react/jsx-runtime";
const i = (e) => /* @__PURE__ */ l("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1rem", height: "1rem", fill: "none", viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ l(
  "path",
  {
    fill: "#212134",
    fillRule: "evenodd",
    d: "M23.604 3.514c.528.528.528 1.36 0 1.887l-2.622 2.607-4.99-4.99L18.6.396a1.322 1.322 0 0 1 1.887 0l3.118 3.118ZM0 24v-4.99l14.2-14.2 4.99 4.99L4.99 24H0Z",
    clipRule: "evenodd"
  }
) }), o = i;
export {
  o as default
};
